// Small helper: play a short "ping" (WebAudio, no asset) + vibrate on mobile.
let ctx = null;

function getCtx() {
  if (!ctx) {
    const AC = window.AudioContext || window.webkitAudioContext;
    if (AC) ctx = new AC();
  }
  return ctx;
}

export function unlockAudio() {
  const c = getCtx();
  if (c && c.state === "suspended") c.resume().catch(() => {});
}

// Browsers require a user gesture before audio can play; unlock on first interaction.
if (typeof window !== "undefined") {
  const h = () => {
    unlockAudio();
    window.removeEventListener("pointerdown", h);
    window.removeEventListener("keydown", h);
    window.removeEventListener("touchstart", h);
  };
  window.addEventListener("pointerdown", h);
  window.addEventListener("keydown", h);
  window.addEventListener("touchstart", h);
}

export function notifyPing() {
  try {
    const c = getCtx();
    if (c) {
      if (c.state === "suspended") c.resume().catch(() => {});
      const now = c.currentTime;
      const o = c.createOscillator();
      const g = c.createGain();
      o.type = "sine";
      o.frequency.setValueAtTime(880, now);
      o.frequency.setValueAtTime(660, now + 0.12);
      g.gain.setValueAtTime(0.0001, now);
      g.gain.exponentialRampToValueAtTime(0.25, now + 0.02);
      g.gain.exponentialRampToValueAtTime(0.0001, now + 0.35);
      o.connect(g);
      g.connect(c.destination);
      o.start(now);
      o.stop(now + 0.36);
    }
  } catch (e) { /* ignore */ }
  try {
    if (navigator.vibrate) navigator.vibrate([120, 60, 120]);
  } catch (e) { /* ignore */ }
}
